module.exports = "https://img.zhijierongxing.com/saas/img/maintain_income.8cebef42.png";